export default __webpack_public_path__ + "static/media/3mm 2.747fcb95.jpg";